import type React from 'react';
import {
  IconGrowth,
  IconRanking,
  IconRelationGraph,
  IconSubscriptionCycle,
  IconWatch,
  type IconProps,
} from './index';

/**
 * 产品 → 图标映射。
 *
 * 每个图标按产品的真实功能选形，而不是按品类套一个通用图：
 * 订阅是周期性账单（闭环箭头）、QuQu 是以我为中心的关系图（中心节点 + 连线）、
 * 薪资奖励官的载体就是手表（表盘）、排名是名次高低（不等高柱形）、
 * 销售智能体是增长（折线）。
 *
 * 这样产品矩阵里五个图标彼此形状差异明显，缩到 16px 也能区分 ——
 * 生成式图标最常见的问题恰恰是五个图看起来像同一团发光的东西。
 */
export const PRODUCT_ICONS: Record<string, React.FC<IconProps>> = {
  dingwuyou: IconSubscriptionCycle,
  ququ: IconRelationGraph,
  'salary-reward': IconWatch,
  'ranking-miniprogram': IconRanking,
  'sales-agent': IconGrowth,
};

export function getProductIcon(id: string): React.FC<IconProps> | undefined {
  return PRODUCT_ICONS[id];
}
